module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("2JQwK"))).then(() => parcelRequire('3a9aZ'));